import { get, post } from 'api/request';
import urls from 'configs/urls';

export const getStaticData = () => get(null, false, urls.commonUrls.getStaticData, null);

export const uploadContent = ({ headers, data }) =>
  post(headers, false, urls.commonUrls.uploadContent, data);

export const searchProducts = ({ data }) => get(null, false, urls.commonUrls.searchProducts, data);
